const steps = {
  shoppingCart: {
    titleLong: 'Warenkorb',
    titleShort: 'Warenkorb',
    id: 1
  },
  address: {
    titleLong: 'Adresse',
    titleShort: 'Adresse',
    id: 2
  },
  payment: {
    titleLong: 'Bezahlung',
    titleShort: 'Bezahlung',
    id: 3
  }
}

export default {
  steps
}
